







































import Vue from 'vue';
import { valueDialog, PREF_FULLSCREEN_VALUE } from './Value';
import { Preferences } from './Preference';


export default Vue.extend({
  data: () => valueDialog,
  computed: {
    isFullscreen(): boolean {
      return this.$vuetify.breakpoint.mdAndDown || this.fullscreen;
    },
    isFullscreenToggleVisible(): boolean {
      return !this.$vuetify.breakpoint.mdAndDown;
    },
  },
  methods: {
    toggleFullscreen() {
      this.fullscreen = !this.fullscreen;

      Preferences.set(PREF_FULLSCREEN_VALUE, this.fullscreen);
    },
  },
});
